import { create } from 'zustand';
import { runExecutor, submitExecutor } from '../services/executor.api';

const useExecutorStore = create((set) => ({
  runResults: {}, // key `${labInternalId}:${questionId}` -> result
  submitResults: {}, // key `${labInternalId}:${questionId}` -> result
  loading: false,
  error: null,

  async run({ labInternalId, questionId, language, code }) {
    set({ loading: true, error: null });
    try {
      const res = await runExecutor({ labInternalId, questionId, language, code });
      const key = `${labInternalId}:${questionId}`;
      const payload = res?.data || res;
      set((state) => ({ runResults: { ...state.runResults, [key]: payload }, loading: false }));
      return payload;
    } catch (err) {
      set({ error: err, loading: false });
      throw err;
    }
  },

  async submit({ labInternalId, questionId, language, code }) {
    set({ loading: true, error: null });
    try {
      const res = await submitExecutor({ labInternalId, questionId, language, code });
      const key = `${labInternalId}:${questionId}`;
      const payload = res?.data || res;
      set((state) => ({ submitResults: { ...state.submitResults, [key]: payload }, loading: false }));
      return payload;
    } catch (err) {
      set({ error: err, loading: false });
      throw err;
    }
  },
}));

export default useExecutorStore;
